import { useState, useRef, useEffect } from "react";
import { FiMoreVertical } from "react-icons/fi";

const ActionsMenu = ({ actions = [], disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, right: 0 });
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        !event.target.closest(".fixed.z-\\[9999\\]")
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleToggleMenu = () => {
    if (disabled) return;

    if (!isOpen && buttonRef.current) {
      // Calculate position relative to viewport
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuPosition({
        top: rect.bottom + window.scrollY + 4, // 4px gap
        right: window.innerWidth - rect.right + window.scrollX,
      });
    }

    setIsOpen(!isOpen);
  };

  const handleActionClick = (action) => {
    action.onClick();
    setIsOpen(false);
  };

  if (actions.length === 0) {
    return null;
  }

  return (
    <>
      <div className="relative" ref={menuRef}>
        <button
          ref={buttonRef}
          type="button"
          onClick={handleToggleMenu}
          disabled={disabled}
          className={`
            inline-flex items-center justify-center w-8 h-8 rounded-full
            ${
              disabled
                ? "text-gray-300 cursor-not-allowed"
                : "text-gray-400 hover:text-gray-600 hover:bg-gray-100"
            }
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
          `}
        >
          <FiMoreVertical className="w-5 h-5" />
        </button>
      </div>

      {isOpen && !disabled && (
        <div
          className="fixed z-[9999] w-48 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          style={{
            top: `${menuPosition.top}px`,
            right: `${menuPosition.right}px`,
          }}
        >
          <div className="py-1">
            {actions.map((action, index) => (
              <button
                key={index}
                onClick={() => handleActionClick(action)}
                disabled={action.disabled}
                className={`
                  w-full text-left px-4 py-2 text-sm flex items-center gap-2
                  ${
                    action.disabled
                      ? "text-gray-300 cursor-not-allowed"
                      : action.variant === "danger"
                        ? "text-red-700 hover:bg-red-50"
                        : "text-gray-700 hover:bg-gray-50"
                  }
                `}
              >
                {action.icon && <action.icon className="w-4 h-4" />}
                {action.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ActionsMenu;
